import { Component, Injector } from "@angular/core";
import { MfBaseComponent, MfTypeInfo } from "@pattonair/material-framework";


const TYPE_INFO: MfTypeInfo = { className: "AucEntryPointComponent" };

@Component({
  selector: "ecom-entry-point",
  templateUrl: "./entry.point.component.html",
  styleUrls: ["./entry.point.component.scss"]
})
export class AucEntryPointComponent extends MfBaseComponent {
  public constructor(
    protected override _injector: Injector,
  ) {
    super(TYPE_INFO, _injector);
  }
}